import React, { useEffect, useState } from 'react';

import { useDependencies } from '../../misc/DependenciesProvider.tsx';
import * as frac_api from "../../api/FracApi.ts";
import * as columns from '../../misc/Columns.ts';
import { DataTable } from '../DataTable.tsx';
import * as constants from '../../misc/Constants.tsx';
import { EditDialog } from '../CommonComps/EditDialog.tsx';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import { Button } from '@mui/material';
import { NewDialog } from '../CommonComps/NewDialog.tsx';


export function UsersPage({ is_admin }: { is_admin: boolean }) {
    const { fracAPI } = useDependencies();
    const [users, setUsers] = useState<frac_api.User[]>([]);
    const columns = getColumnInfo();
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [showAddNew, setShowAddNew] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>(null);
    const { showMessage } = useSnackbarMessage();
    const addColumns = getColumnInfoForAdd(columns);
    const lovs = {
        'roles': [
            { 'label': 'ADMIN', 'value': 'ADMIN' },
            { 'label': 'USER', 'value': 'USER' }
        ]
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const users = await fracAPI.getUsers();
        setUsers(users);
    }

    const isUserValid = (user: frac_api.User) => {
        if (!user.email) {
            showMessage("Email is required");
            return false;
        }

        // is email valid?
        const emailRegex = /\S+@\S+\.\S+/;
        if (!emailRegex.test(user.email)) {
            showMessage("Email is not valid");
            return false;
        }

        if (!user.full_name) {
            showMessage("Full Name is required");
            return false;
        }

        if (!user.role) {
            showMessage("Role is required");
            return false;
        }

        if (!user.password) {
            showMessage("Password is required");
            return false;
        }

        if (user.password.length < 8) {
            showMessage("Password must be at least 8 characters long");
            return false;
        }

        if (!user.activated) {
            showMessage("Activated is required");
            return false;
        }

        return true;
    }



    const handleDelete = async (email: string) => {
        try {

            await fracAPI.deleteUser(email);

        } catch (error) {
            console.error("Error deleting record: " + error);
            showMessage("Error deleting record. Please try again.");
        }
    }

    function getColumnInfoForAdd(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
        const addPassword = [
            ...columns,
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'str',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'Password',
                'editable': true,
                'id': 'password',
            }
        ];

        return addPassword;
    }

    function getColumnInfo(): columns.ColumnInfo[] {

        const columns: columns.ColumnInfo[] = [
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'str',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'ID',
                'editable': false,
                'id': 'id',
            },
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'str',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'Email',
                'editable': true,
                'id': 'email',
            },
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'str',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'Full Name',
                'editable': true,
                'id': 'full_name',
            },
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'lov',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'Role',
                'editable': true,
                'id': 'role',
                'lov': 'roles',


            },
            {
                'disp_width': '50px',
                'rows': 1,
                'wrap': true,
                'type': 'boolean',
                'max_disp_chars': 300,
                'hidden': false,
                'disp_name': 'Activated',
                'editable': true,
                'id': 'activated',
            },
        ]

        const edit_col = {
            'rows': 1,
            'wrap': true,
            'type': 'action',
            'max_disp_width': 20,
            'hidden': false,
            'disp_name': 'Edit',
            'editable': false,
            'id': constants.editActionId,
            'action': 'Edit',
            'perform_action': async (x: frac_api.User) => {
                setShowEdit(true);
                setEditData(x);
            }
        }
        columns.push(edit_col);

        const del_col = {
            'rows': 1,
            'wrap': true,
            'type': 'action',
            'max_disp_width': 20,
            'hidden': false,
            'disp_name': 'Delete',
            'editable': false,
            'id': constants.deleteActionId,
            'action': 'Delete',
            'perform_action': async (x: frac_api.User) => {
                if (window.confirm("Are you sure you want to delete this record?")) {
                    handleDelete(String(x['email']));
                    loadData();
                }
            }
        }
        columns.push(del_col);

        return columns;
    }

    const createUser = async (user: frac_api.User) => {
        try {
            if (!isUserValid(user)) {
                return;
            }

            delete user['id'];
            await fracAPI.createUser(user);
            setShowAddNew(false);
            await loadData();

        } catch (error) {
            console.error("Error creating record: " + error);
            showMessage("Error creating record. Please try again.");
        }
    }

    return (
        <div>
            <DataTable
                showExport={is_admin}
                getTokenFuncAsync={() => null}
                keyname={'id'}
                data={users}
                columns={columns}
                defaultSortColumn={"id"} >

                <Button
                    variant="outlined"
                    onClick={() => setShowAddNew(true)}
                >
                    Add New
                </Button>

            </DataTable>

            {showAddNew &&
                <NewDialog
                    columns={addColumns}
                    onHandleAdd={createUser}
                    lovs={lovs}

                    onHandleClose={() => {
                        setShowAddNew(false);
                    }}
                />

            }



            {editData && showEdit &&
                <EditDialog
                    initialEditData={editData}
                    columns={columns}
                    lovs={lovs}

                    onUpdated={async (x: frac_api.User) => {
                        // TODO: fix this
                        if (x.id === undefined) {
                            showMessage("Internal error, no id present in record. Please try again.");
                            return;
                        }

                        await fracAPI.updateUser({
                            id: x.id,
                            email: x.email,
                            full_name: x.full_name,
                            role: x.role,
                            activated: x.activated
                        });

                        loadData();
                    }}

                    onClose={() => {
                        setShowEdit(false);
                        setEditData(null);
                    }}

                />
            }
        </div>
    );
}